import swal from 'sweetalert'
import { merge } from 'lodash'

export default {
  /**
   * Base sweet alert. Handles promise rejection.
   *
   * @return Promise
   */
  base (options = {}) {
    return swal(options)
      .then((result) => {
        if (result === null) {
          return Promise.reject(new Error('Alert was rejected.'))
        } else {
          return Promise.resolve(result)
        }
      })
  },

  /**
   * Show a warning alert for when their are unsaved changes.
   *
   * @return Promise
   */
  changes (options = {}) {
    return this.base(merge({
      title: 'You have unsaved changes.',
      text: 'Are you sure you want to perform this action?',
      icon: 'warning',
      buttons: {
        cance: true,
        confirm: true
      }
    }, options))
  },

  /**
   * Show an info alert.
   *
   * @return Promise
   */
  info (options = {}) {
    return this.base(merge({
      icon: 'info',
      buttons: {
        confirm: true,
        cancel: false
      }
    }, options))
  },

  /**
   * Show a success alert.
   *
   * @return Promise
   */
  success (options = {}) {
    return this.base(merge({
      title: 'Success!',
      icon: 'success',
      timer: 2500,
      closeOnClickOutside: false,
      closeOnEsc: false
    }, options))
  },

  /**
   * Timed success will always resolve the promise as it is assumed that this is used
   * when the only option is a success.
   *
   * @return Promise
   */
  timedSuccess (options = {}) {
    return this.success(options)
      .catch(() => {
        return Promise.resolve()
      })
  },

  /**
   * Show a warning confirmation alert.
   *
   * @return Promise
   */
  confirm (options = {}) {
    return this.base(merge({
      title: 'Are you sure?',
      icon: 'warning',
      buttons: {
        cancel: true,
        confirm: true
      },
      dangerMode: true,
      closeOnClickOutside: false
    }, options))
  },

  /**
   * Show an error alert for when deleting.
   *
   * @return Promise
   */
  delete (options = {}) {
    return this.base(merge({
      dangerMode: true,
      title: 'Danger ahead!',
      text: 'Are you sure you want to perform this delete?',
      icon: 'error',
      buttons: {
        cancel: true,
        confirm: true
      },
      closeOnClickOutside: false,
      closeOnEsc: false
    }, options)).catch(error => error)
  },

  /**
   * Show a error alert.
   *
   * @return Promise
   */
  error (options = {}) {
    return this.base(merge({
      title: 'We encountered an error.',
      icon: 'error',
      buttons: {
        cancel: false,
        confirm: true
      }
    }, options))
  }
}
